import { GetProjectsListParams } from "@evergis/api";
import { Sort, SortType } from "@evergis/ui";
import { useSelector } from "react-redux";
import { useResourceSelectorContext } from "../../../components/ResourceSelector/ResourceSelector";
import { getLocationQuery } from "../../../ducks/location/selectors";

import { layers } from "../../../resources/layers";
import { projects } from "../../../resources/projects";
import { tables } from "../../../resources/tables";

import { getFetchParams } from "../../../ducks/catalog/selectors";
import { useResourceType } from "../../../hooks/useResourceType";
import { SortOrder } from "../components/Sort/types";
import { ResourceViewType } from "../components/ViewType/types";

export type Resources = typeof projects | typeof layers | typeof tables;

export enum ResourceCategory {
  User = "user",
  Shared = "shared",
  Public = "public",
  Favorites = "favorites",
}

export type ResourcesFetchParams = Pick<GetProjectsListParams, "filter" | "offset" | "limit"> & {
  sort?: Sort;
  category?: ResourceCategory;
  geometryFilter?: string;
  types?: string[];
};

export const isFilterEmpty = (fetchParams: ResourcesFetchParams): boolean => {
  return fetchParams.filter === "" && fetchParams.category === ResourceCategory.User;
};

export const RESOURCES_LIMIT = 0;

export const defaultFetchParams = {
  filter: "",
  sort: {
    changedDate: SortOrder.DES as SortType,
  },
  viewType: ResourceViewType.Grid,
  category: ResourceCategory.User,
  geometryFilter: "",
  types: [],
  limit: RESOURCES_LIMIT,
  offset: 0,
};

export const useFetchParams = (): ResourcesFetchParams => {
  const [resourceType] = useResourceType();
  const { active: resourceSelectorActive, resourceType: selectorResourceType } = useResourceSelectorContext();
  const fetchParams = useSelector(getFetchParams(resourceSelectorActive ? selectorResourceType : resourceType));
  const { types } = useSelector(getLocationQuery);

  return {
    ...fetchParams,
    types: resourceSelectorActive ? ["PostgresLayerService"] : types || fetchParams.types,
  };
};
